import { render } from "./TeamLibrary.vue?vue&type=template&id=a5b49b36&scoped=true"
import script from "./TeamLibrary.vue?vue&type=script&lang=js"
export * from "./TeamLibrary.vue?vue&type=script&lang=js"

import "./TeamLibrary.vue?vue&type=style&index=0&id=a5b49b36&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5b49b36"]])

export default __exports__